import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { HELP_CENTER_ATTENDEE_URL } from '../../constants';
import './RatingDetailModal.scss';

// TODO: Update with correct copy and remove mock
const DISCLAIMER_TEXT = gettext(
    'All the disclaimer and legal content necessary to be covered, like we are not currently showing everything and all the stuff here because this is a beta.',
);
// TODO: Update with correct copy and remove mock
const HELPER_CENTER_LINK_TEXT = gettext('Learn more in the Help center.');

export const Disclaimer = () => {
    return (
        <div className="disclaimer__container">
            <p className="eds-text-bs eds-text-weight--heavy">
                {DISCLAIMER_TEXT}
            </p>

            <a
                href={HELP_CENTER_ATTENDEE_URL}
                className="eds-text-bm helper-text--link eds-link"
            >
                {HELPER_CENTER_LINK_TEXT}
            </a>
        </div>
    );
};
